<template>
  <div>
    <div style="padding-top: 55px" />

    <h1>{{ productName }}</h1>
  </div>
</template>

<script>
export default {
  name: "Admin",
  computed: {
    productName() {
      return this.$store.state.info.name || 'XAIMED AI';
    }
  }
};
</script>
